import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';
import { useStore } from '../context/StoreContext';
import * as FiIcons from 'react-icons/fi';
const { FiCheckCircle, FiUserPlus, FiPieChart, FiSettings } = FiIcons;

export const EventLayout = () => {
  const { currentEvent, staffName } = useStore();

  return (
    <div className="min-h-screen flex flex-col bg-padua-ivory">
      {/* Top Navigation Bar optimized for iPad */}
      <header className="bg-padua-green text-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center space-x-4">
              <div className="flex flex-col">
                <span className="font-cinzel text-xl tracking-wider text-padua-gold font-semibold">Padua Weddings</span>
                <span className="text-sm text-padua-ivory/80">{currentEvent?.event_name || 'Event Check-In'}</span>
              </div>
            </div>
            
            <nav className="hidden md:flex space-x-2">
              <NavButton to="/" icon={<FiCheckCircle />} label="Check-In" />
              <NavButton to="/walk-in" icon={<FiUserPlus />} label="Walk-In" />
              <NavButton to="/dashboard" icon={<FiPieChart />} label="Dashboard" />
            </nav>

            <div className="flex items-center space-x-4">
              <div className="text-sm text-right hidden sm:block">
                <p className="text-padua-ivory/60 text-xs uppercase tracking-wider">Staff</p>
                <p className="font-medium">{staffName}</p>
              </div>
              <NavLink to="/admin" className="p-2 hover:bg-white/10 rounded-full transition-colors">
                <FiSettings size={24} />
              </NavLink>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Nav (Bottom) */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50 flex justify-around p-2 pb-safe">
        <MobileNavButton to="/" icon={<FiCheckCircle />} label="Check-In" />
        <MobileNavButton to="/walk-in" icon={<FiUserPlus />} label="Walk-In" />
        <MobileNavButton to="/dashboard" icon={<FiPieChart />} label="Stats" />
      </div>

      <main className="flex-1 w-full max-w-5xl mx-auto p-4 sm:p-6 lg:p-8 pb-24 md:pb-8">
        <Outlet />
      </main>
    </div>
  );
};

const NavButton = ({ to, icon, label }) => (
  <NavLink 
    to={to} 
    className={({isActive}) => `
      flex items-center space-x-2 px-4 py-3 rounded-lg font-medium transition-all
      ${isActive ? 'bg-padua-gold text-white' : 'text-padua-ivory hover:bg-white/10'}
    `}
  >
    <span className="text-xl">{icon}</span>
    <span>{label}</span>
  </NavLink>
);

const MobileNavButton = ({ to, icon, label }) => (
  <NavLink 
    to={to} 
    className={({isActive}) => `
      flex flex-col items-center justify-center w-full py-2 space-y-1
      ${isActive ? 'text-padua-gold' : 'text-gray-500'}
    `}
  >
    <span className="text-2xl">{icon}</span>
    <span className="text-[10px] uppercase tracking-wider font-semibold">{label}</span>
  </NavLink>
);